import {useEffect,useState} from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import axios from 'axios'
import {useSelector, useDispatch} from 'react-redux';
import { ArrowDropDownCircleOutlined, Edit, ScoreOutlined } from '@mui/icons-material';
import {Button, CircularProgress, Snackbar, TablePagination} from '@mui/material';
import ContentView from '../Components/ContentView';
import { styled, alpha,useTheme } from '@mui/material/styles';
import UserInput from "../Components/UserInput"
import { add_report, add_reports } from '../Redux/reportsSlice';
import { useNavigate } from 'react-router-dom';

const ContainerBox = styled(Box, {
})(({ theme}) => ({
transition: theme.transitions.create('width', {
easing: theme.transitions.easing.sharp,
duration: theme.transitions.duration.enteringScreen,
}),
overflowY: 'auto',
overflowX: 'hidden',
'&::-webkit-scrollbar': {
    width: 10,
    backgroundColor: '#000000'
  },
'&::-webkit-scrollbar-thumb': {
    backgroundColor: '#ffffff',
    borderRadius: 10
  },
  background:"#000",
  maxHeight:400,
  minHeight:200,
  borderRadius:10
})
);

function Row(props) {

const { row,submitting,loading,handleAccept,handleScore,setVisible,setMessage } = props;
const test = useSelector(state => state?.test.test);
const navigate = useNavigate()
const dispatch = useDispatch()
const [open,setOpen] = useState(false)
const [change,setChange] = useState(false)
const [changing,setChanging] = useState(false)
const [score,setScore] = useState(row?.score)


return (
    <>
    <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
        <TableCell>
        <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
        >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </IconButton>
        </TableCell>
        <TableCell align="left">{row?.last_name}</TableCell>
        <TableCell align="left">{row?.first_name}</TableCell>
        <TableCell align="left">{row?.email}</TableCell>
        <TableCell align="left">{row?.score}</TableCell>
        <TableCell align="left">
            <Typography sx={{fontSize:12,fontFamily:"dinofans",color:(row?.conclusion === "accept" ? "green" : row?.conclusion === "fail" ? "red" : "gold")}}>
                {row?.conclusion === "accept" ? "ACCEPTED" : row?.conclusion === "fail" ? "REJECTED"  : "PENDING" }
            </Typography>
        </TableCell>
        <TableCell align="left">
            <Button onClick={(e)=>{
                e?.preventDefault()
                handleAccept(row?.email,"accept")
            }} disabled={(submitting || row?.conclusion === "accept") ? true : false || row?.isDisqualified} sx={{background:"gold",color:"#000",fontFamily:"dinofans",fontSize:12}} variant="outlined">
                 {
                    submitting ? <CircularProgress size={15} sx={{color:"#000"}}/> : "ACCEPT"
                }
            </Button>
        </TableCell>
        <TableCell align="left">
            <Button onClick={(e)=>{
                e?.preventDefault()
                handleAccept(row?.email,"fail")
            }}  disabled={(loading || row?.conclusion === "fail") ? true : false || row?.isDisqualified} sx={{background:"maroon",color:"white",fontFamily:"dinofans",fontSize:12}} variant="outlined">
                {
                    loading ? <CircularProgress size={15} sx={{color:"gold"}}/> : "REJECT"
                }
            </Button>
        </TableCell>
    </TableRow>
    <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={7}>
        <Collapse in={open} timeout="auto" unmountOnExit>
           <Box sx={{ margin: 1 }}>
                <Typography variant="h6" gutterBottom component="div">
                    Assessment Content
                </Typography>
                <ContainerBox sx={{margin:1,padding:1,color:"gray",textAlign:"left",marginBottom:0}}>
                    <Typography sx={{fontFamily:"dinofans",margin:1,fontSize:13}}>
                        Assessment Detail
                    </Typography>
                    <Box width="70%" justifyContent="space-between" alignItems="center" flexDirection="row"  display="flex" flexWrap="wrap">
                        <Box>
                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                title
                            </Typography>
                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                {test?.name}
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                Total of questions answered
                            </Typography>
                            <Typography sx={{marginBottom:1,fontSize:13,color:"#ff0"}}>
                                {row?.response?.test?.length} / {test?.questions} questions
                            </Typography>
                        </Box>
                        <Box>
                            <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                                Field & specialty
                            </Typography>
                            <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                                {test?.field} / {test?.specialty}
                            </Typography>
                        </Box>
                    </Box>
                    <Typography sx={{fontFamily:"dinofans",marginBottom:1,fontSize:12}}>
                        Description
                    </Typography>
                    <Typography sx={{marginBottom:1,fontSize:13,color:"#fff"}}>
                        {test?.description}
                    </Typography>
                    <Button disabled={row?.isDisqualified}  onClick={(e)=>{
                        e?.preventDefault()
                        if(row?.isDisqualified){
                            setMessage("this candidate has been disqualified")
                            setVisible(true)
                        }else{
                            dispatch(add_report(row))
                            navigate("/candidateDetail")
                        }
                    }} sx={{background:"#fff",color:"black",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12}} variant="contained">
                       View
                    </Button>
                </ContainerBox>
                <ContentView title="Status" content= {row?.conclusion === "accept" ? "ACCEPTED" : row?.conclusion === "fail" ? "REJECTED"  : "PENDING" }/>
                <Button disabled={loading || row?.isDisqualified}  onClick={()=>{
                    setChange(prev=>!prev)
                }} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                    Update Score
                </Button>
                {change && (
                    <Box mb={2}>
                        <UserInput
                            label="score"
                            input={score}
                            setInput={setScore}
                            isPass={false}
                        >
                            <ScoreOutlined/>
                        </UserInput>
                        <Button onClick={(e)=>{
                            e?.preventDefault()
                            handleScore(row?.email,score,setScore,setChange,setChanging)
                        }} disabled={changing } sx={{background:"gold",color:"black",height:30,fontFamily:"dinofans",fontSize:12}}>
                            {
                                changing ? <CircularProgress size={15}/> : "change"
                            }
                        </Button>														
                    </Box>
                    )
                }
                <Box>
                    <Button disabled={((submitting || loading || row?.isDisqualified) || row?.conclusion === "accept") ? true : false}  onClick={()=>{
                        handleAccept(row?.email,"accept")
                    }} sx={{background:"maroon",color:"white",margin:1,fontFamily:"dinofans",fontSize:12}} variant="outlined">
                        {
                            submitting ? <CircularProgress size={15} sx={{color:"black"}}/> : "ACCEPT"
                        }
                    </Button>
                    <Button disabled={((submitting || loading || row?.isDisqualified) || row?.conclusion === "fail")}  onClick={()=>{
                        handleAccept(row?.email,"fail")
                    }} sx={{background:"gold",color:"black",margin:1,borderColor:"gold",fontFamily:"dinofans",fontSize:12}} variant="contained">
                        {
                            loading ? <CircularProgress size={15} sx={{color:"black"}}/> : "Reject"
                        }
                    </Button>
                </Box>
            </Box>
        </Collapse>
        </TableCell>
    </TableRow>
    </>
);
}

Row.propTypes = {
row: PropTypes.shape({
    score: PropTypes.number.isRequired,
    last_name: PropTypes.string.isRequired,
    first_name: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired
}).isRequired,
};

export default function CollapsibleTable({filterItem,setCandidate}) {

const theme = useTheme();
const test = useSelector(state => state?.test.test);
const data = useSelector(state => state?.reports.reports);
const user = useSelector(state => state?.auth.user);
const [submitting,setSubmitting] = useState(false)
const [loading,setLoading] = useState(false)
const [expanded, setExpanded] = useState(false);
const [visible,setVisible] = useState(false)
const [accepted,setAccepted] = useState(0)
const [open, setOpen] = useState(false);
const [message,setMessage] = useState('')
const dispatch = useDispatch()
const [newData,setNewData] = useState(data)
const [order, setOrder] = useState('asc');
const [orderBy, setOrderBy] = useState('calories');
const [selected, setSelected] = useState([]);
const [page, setPage] = useState(0);
const [rowsPerPage, setRowsPerPage] = useState(10);

const handleSnackbarClose = ()=>{
    setVisible(false)
}

async function handleAccept(email,typ) {
try{

    if (typ === "accept") {
        setSubmitting(true)
    } else {
        setLoading(true)
    }
    
    const send_data = {
        id:test.id,
        email:email,
        type:typ
    }

    const URL = `${process.env.REACT_APP_SERVER_AUTH_URL}set-accept/` 

    const setPass = await axios.put(URL,send_data,{
        headers:{
                "Content-Type":"application/json",
                "Authorization":`Bear ${user?.accessToken}`
            }
    }).catch(err=>{
        setSubmitting(false)
        setLoading(false)
        setMessage("connection error")
        setVisible(true)
    })
    
    if (setPass?.data.success && setPass.status == 200) {
        
        setCandidate(setPass?.data?.reports?.filter(item=>item?.conclusion === "accept"))
        const filterDta = setPass?.data.reports.filter((item)=>item.email !== email)
        dispatch(add_reports(filterDta))
        
        // console.log(setPass?.data)

        setSubmitting(false)
        setLoading(false)
    }else{
        setSubmitting(false)
        setLoading(false)
    }
    setMessage(setPass?.data?.message)
    setVisible(true)
}catch(err){
    console.log(err)
    setSubmitting(false)
    setLoading(false)
}
}

async function handleScore(email,score,setScore,setChange,setChanging){
try {

    if (score !== null) {

        const data = {
            id:test.id,
            email:email,
            score:score
        }
        setChanging(true)

        const handleSend = await axios.put(`${process.env.REACT_APP_SERVER_AUTH_URL}set-score/`,data,{
                headers:{
                        "Content-Type":"application/json",
                        "Authorization":`Bear ${user?.accessToken}`
                    }
            }).catch(err=>{console.log(err)})

        if (handleSend?.status == 200 && handleSend?.data.success == true) {
            const filterDta = newData.filter((item)=>item.email !== email)
    
            const newFilterData = [...filterDta,handleSend?.data.report]
            setNewData(newFilterData)
            setChanging(false)
            setScore(null)
            setChange(false)
            setMessage(handleSend.data?.message)
            setOpen(true)

        } else {
            setMessage(handleSend?.data?.message)
            setOpen(true)
            setChanging(false)
        }
    } else {
        setMessage("write down the score")
        setOpen(true)			
    }

} catch (error) {
    console.log(error)
}
}

const handleChangePage = (event, newPage) => {
    setPage(newPage);
};

const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
};

const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - newData.length) : 0;

useEffect(()=>{
setNewData(data)
},[data])

return (
    <>
        <Snackbar 
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'left',
            }} 
            message={message} 
            onClose={handleSnackbarClose} 
            open={visible} 
            autoHideDuration={2000}
        />
         {newData?.filter(item=>item?.conclusion === filterItem )?.length == 0 && (
            <Box sx={{width:"100%",alignItems:"center",justifyContent:"center",flexDirection:"row",marginTop:2,display:"flex"}}>
                <Edit fontSize='small' name="edit" sx={{color:"gold"}}/>
                <Typography sx={{color:"white",padding:1,fontSize:12}}>
                    None of all participant have those params
                </Typography>
            </Box>
            )
        }
        {newData?.filter(item=>item?.conclusion === filterItem )?.length > 0 && (
            <>
            <TableContainer component={Paper} sx={{width:"95%",margin:1}}>
                <Table aria-label="collapsible table">
                    <TableHead>
                    <TableRow>
                        <TableCell/>
                        <TableCell>Last&nbsp;Name</TableCell>
                        <TableCell align="left">First&nbsp;Name</TableCell>
                        <TableCell align="left">Email</TableCell>
                        <TableCell align="left">Score&nbsp;(%)</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Accept</TableCell>
                        <TableCell align="left">Reject</TableCell>
                    </TableRow>
                    </TableHead>
                    <TableBody>
                    {newData?.filter(item=>item?.conclusion === filterItem )?.map((row,index) => (
                        <Row setVisible={setVisible} setMessage={setMessage} key={index} row={row} submitting={submitting} loading={loading} handleAccept={handleAccept} handleScore={handleScore} />
                    ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                labelRowsPerPage={<Typography sx={{fontSize:11,color:"#ff0"}}>
                                    assessment per page
                                </Typography>}
                count={newData.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
            </> 
            )}
    </>

);
}
